import React, { useEffect, useRef, useState } from 'react'
import { Form, message, Select, Table, Tooltip, Spin } from 'antd'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { FaPlus, FaEdit, FaEye, FaInfoCircle } from 'react-icons/fa'
import { RiDeleteBin6Line } from 'react-icons/ri'
import { CustomSelect, Inputs, DeleteModal, CustomModal, QRCodeScanner, Datepicker, VehicleMap, SearchOrganizations, SearchDeviceUser, TableSkeleton } from '../../Components'
import { GET, POST } from '../../utils/apis'
import { setDevicesData, setTotalDevices, setDevicesFilterData, setAvailableSerialNumbers, setTotalFilteredDevices, setDevicePercentage } from '../../Redux/actions/deviceAction'
import { fetchAllOrganization, fetchDevices, fetchSerialNumbers, fetchUnassociatedVehicle, fetchUsers, fetchVehicles, formatDate, stringLimiter, verifyToken, vehicleLabel } from '../../utils/helpers'
import { setTotalVehicles, setVechiclesData } from '../../Redux/actions/vehiclesAction'
import { secureApi } from '../../Config/api'
import { allPaths, dateFormate, pageSizeOptions, tableDateFormate, translations } from '../../utils/constants'
import { DatabaseZap, Search, Building2, Users, ArrowDownToLine, ArrowUpDown } from 'lucide-react'
import { setOrganizationFilter } from '../../Redux/actions/organizationActions'
import moment from 'moment'
import { setUserData } from '../../Redux/actions/userAction'
import { setDeviceInfoRedux } from '../../Redux/actions/deviceInfoAction'
import { setUsersAdminFilter } from '../../Redux/actions/usersAdminFilterActions'
import { setDevicePageNumber } from '../../Redux/actions/filterDevicesAction'
import SearchDeviceType from '../../Components/SearchUser/SearchDeviceType'
import axios from 'axios'

const Devices = ({ language }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const devicesFromRedux = useSelector((state) => state.deviceReducer?.devices)
  const FilterDevicesFromRedux = useSelector((state) => state.deviceReducer?.filterDevice)
  const user = useSelector(state => state?.authReducer?.user)
  const organizationDetails = useSelector(state => state?.authReducer?.organization)
  const organizationFilter = useSelector(state => state.organizationReducer.organizationFilter)
  const vehicles = useSelector(state => state.vehiclesReducer?.vehicles)
  const currentPage = useSelector(state => state.filterDeviceReducer?.pageNumber || 1)
  const organizationFromRedux = useSelector((state) => state.organizationReducer?.allOrganizations)
  const usersAdminFilter = useSelector(state => state.usersAdminFilterReducer?.usersAdminFilter)
  const organizationCount = useSelector(state => state.organizationReducer?.orgSelectionCount || 0)
  const deviceSelectionCount = useSelector(state => state.deviceTypeReducer?.deviceSelectionCount || 0)
  const userCount = useSelector(state => state.userReducer?.userSelectionCount || 0)
  const DeviceTypeCount = useSelector(state => state.deviceReducer?.deviceTypeCount || 0)
  const selectedDeviceTypes = useSelector(state => state.deviceTypeReducer?.deviceTypeFilter || [])
  const availableSerials = useSelector(state => state.deviceReducer?.availableSerialNumbers)
  const totalFilteredDevices = useSelector(state => state.deviceReducer?.totalFilteredDevices);
  let authUser = user
  const userId = user?.id
  const [addDevice] = Form.useForm()
  const [editUserForm] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [viewModal, setViewModal] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [searchModal, setSearchModal] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [userToDelete, setUserToDelete] = useState(null)
  const [devices, setDevices] = useState([])
  const [vehicleLoading, setVehicleLoading] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [selectedLogo, setSelectedLogo] = useState(null)
  const [addDataLoading, setAddDataLoading] = useState(false)
  const [editDataLoading, setEditDataLoading] = useState(false)
  const [toEdit, setToEdit] = useState(null)
  const [unassociatedVehicles, setUnassociatedVehicles] = useState([])
  const [selectedDeviceType, setSelectedDeviceType] = useState('router')
  const [selectedRouterType, setSelectedRouterType] = useState('elmec')
  const [deviceInfo, setDeviceInfo] = useState(null)
  const [organizationId, setOrganizationId] = useState(organizationDetails?.id)
  const [searchQuery, setSearchQuery] = useState('')
  const [sortOrder, setSortOrder] = useState('') // '' = default order, 'asc' | 'desc' by created_at
  const [selectedOrganizations, setSelectedOrganizations] = useState([])
  const [organizations, setOrganizations] = useState([])
  const [searchUserModal, setSearchUserModal] = useState(false)
  const [users, setUsers] = useState([])
  const [selectedUsers, setSelectedUsers] = useState([])
  const [initialLoading, setInitialLoading] = useState(false)
  // First page fetch shows a skeleton instead of the empty state; later
  // fetches (search, filters, paging) keep the table and overlay a spinner.
  const [tableLoading, setTableLoading] = useState(true)
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false)
  const [selectOrgFilter, setSelectOrgFilter] = useState(organizationId)
  const [pageSize, setPageSize] = useState(10)
  const [totalItems, setTotalItems] = useState(0)
  const [deviceTypeCounts, setDeviceTypeCounts] = useState([])
  const [searchDeviceTypeModal, setSearchDeviceTypeModal] = useState(false)
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [isLoading, setIsLoading] = useState(true)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [loadingFormData, setLoadingFormData] = useState(false);
  // console.log('devicesFromRedux length', devicesFromRedux?.length)

  useEffect(() => {
    verifyToken(history, dispatch)
    addDevice.setFieldsValue({ deviceType: 'router' })
    addDevice.setFieldsValue({ routerType: 'elmec' })
    fetchDevices({ setDevicesData, setDevicePercentage, setTotalDevices, dispatch, setDevices, user, organizationId })
    fetchVehicles({ setTotalVehicles, setVechiclesData, dispatch, user, organizationId })
    fetchUsers({ setLoading, setUsers, dispatch, setUserData, authUser, organizationId })
    fetchSerialNumbers({ dispatch, selectedRouterType, setAvailableSerialNumbers })
    fetchAllOrganization({ dispatch })
    setOrganizations(organizationFromRedux)
    fetchFilteredDevices()
  }, [])

  useEffect(() => {
    fetchSerialNumbers({ dispatch, selectedRouterType, setAvailableSerialNumbers })
  }, [selectedRouterType])

  // The mount-time copy runs before fetchAllOrganization's dispatch lands, so
  // the org dropdowns stayed empty; keep local state in sync with redux.
  useEffect(() => {
    setOrganizations(organizationFromRedux)
  }, [organizationFromRedux])

  useEffect(() => {
    // While the edit modal is open its own org/type handlers drive the list —
    // this page-filter refetch would clobber it with the wrong organization.
    if (editModal) return
    fetchUnassociatedVehicle({ setUnassociatedVehicles, selectOrgFilter, organizationId, device_type: selectedDeviceType, user })
  }, [selectedDeviceType, selectOrgFilter])

  useEffect(() => {
    if (FilterDevicesFromRedux?.length === 0) {
      setInitialLoading(true)
      const timeout = setTimeout(() => {
        setInitialLoading(false)
      }, 200)
      return () => clearTimeout(timeout)
    } else {
      setInitialLoading(false)
    }
  }, [FilterDevicesFromRedux])

  useEffect(() => {
    if (organizationFilter) {
      fetchDevices({ setDevicesData, setDevicePercentage, setTotalDevices, dispatch, setDevices, user, organizationId: organizationFilter })
    }
  }, [organizationFilter])

  useEffect(() => {
    fetchFilteredDevices()
  }, [organizationFilter, searchQuery, usersAdminFilter, selectedDeviceTypes, currentPage, pageSize, sortOrder])

  useEffect(() => {
    fetchDeviceInfo()
  }, [selectedDate, selectedRecord])

  const fetchFilteredDevices = async () => {
    setTableLoading(true)
    try {
      const params = {
        user_id: user?.id,
        ...(user?.role === 'superAdmin'
          ? { organization_id: organizationFilter }
          : { selectUSerId: usersAdminFilter }),
        deviceTypes: selectedDeviceTypes,
        resourceType: 'devices',
        searchQuery,
        ...(sortOrder ? { sortBy: 'created_at', sortOrder } : {}),
        page: currentPage,
        limit: pageSize
      }
      // console.log(params, 'params')
      const response = await secureApi?.get(GET?.GET_ORGANIZATION_FILTER, { params })
      // console.log(response, 'response')
      if (response?.success) {
        setDeviceTypeCounts(response?.deviceTypeCounts || [])
        dispatch(setDevicesFilterData(response?.data))
        dispatch(setTotalFilteredDevices(response?.total || 0));
        setTotalItems(response?.total || 0)
      }
      else {
        message.error(response?.message || 'Failed to fetch devices.')
      }
    }
    catch (error) {
      message.error('Error fetching filtered devices.')
    }
    finally {
      setTableLoading(false)
      setHasLoadedOnce(true)
    }
  }

  // The device-info call returns the raw GPS trace first (snapped=false)
  // while the road-snapped version is computed server-side; poll a few
  // times until it flips so the drawer ends up with the road line.
  const snapTimerRef = useRef(null)
  const fetchDeviceInfo = async (attempt = 0) => {
    const serialNumber = selectedRecord?.serial_number || null
    if (attempt === 0) clearTimeout(snapTimerRef.current)
    if (!serialNumber || selectedRecord?.device_type !== 'router') {
      // Drawer closed or a non-router device: nothing to locate.
      setDeviceInfo(null)
      setIsLoading(false)
      return
    }
    if (attempt === 0) setIsLoading(true)

    // console.log(selectedRecord, 'selectedRecord')
    // console.log(serialNumber, 'serialNumber')
    try {
      // if (!serialNumber) {
      //   message.error("Serial number is required.")
      //   return
      // }
      let formattedDate = null;
      if (selectedDate) {
        const m = moment(selectedDate)
        if (m.isValid()) {
          formattedDate = m.format(tableDateFormate)
        }
        else {
          // console.error("Selected date is invalid, skipping date param.");
        }
      }
      const response = await secureApi.get(GET?.GET_DEVICE_INFO, {
        params: { serialNumber, formattedDate }
      })
      if (response?.success === true) {
        setDeviceInfo(response?.data)
        dispatch(setDeviceInfoRedux(response?.data))
        setIsLoading(false)
        if (response?.data?.snapped === false && attempt < 5) {
          snapTimerRef.current = setTimeout(() => fetchDeviceInfo(attempt + 1), 4000)
        }
      }

      else if (response?.success === false) {
        setDeviceInfo(null)
        // message.error(response.data?.message)
        setIsLoading(false)
      }
    }
    catch (error) {
      setIsLoading(false)

    }
  }

  const handleDeviceTypeChange = (value) => {
    setSelectedDeviceType(value)
    addDevice.setFieldsValue({
      deviceType: value,
      vehicleAssociation: null,
      serialNumber: null
    })
  }

  const handleRouterTypeChange = (value) => {
    setSelectedRouterType(value)
    addDevice.setFieldsValue({ routerType: value, serialNumber: null })
  }

  // "Name (registering number)" — the plate alone doesn't identify a bus for
  // the operator.
  // Name · targa · matricola (shared helper) — same label in the association
  // dropdowns and the table's Association column.
  const vehicleOptionLabel = vehicleLabel

  // The association list follows the org + device type chosen in the EDIT
  // form (not the page-level filter): routers only see vehicles that have no
  // router yet, every other type sees all of the org's vehicles — the
  // backend applies that rule from device_type.
  const refetchEditAssociationList = (orgId, deviceType) => {
    const effectiveOrg = orgId || organizationId
    if (!effectiveOrg) return
    fetchUnassociatedVehicle({
      setUnassociatedVehicles,
      selectOrgFilter: effectiveOrg,
      organizationId: effectiveOrg,
      device_type: deviceType,
      user,
    })
  }

  const selectEditOrganization = (orgId) => {
    refetchEditAssociationList(orgId, editUserForm.getFieldValue('deviceType'))
    editUserForm.setFieldsValue({ vehicleAssociation: null })
  }

  const handleDeviceEditTypeChange = async (value) => {
    setSelectedDeviceType(value)

    if (toEdit?.organization_id) {
      await fetchVehicles({
        setTotalVehicles,
        setVechiclesData,
        dispatch,
        user,
        organizationId: toEdit.organization_id
      })
    }

    editUserForm.setFieldsValue({ deviceType: value })
    refetchEditAssociationList(editUserForm.getFieldValue('organization'), value)
  }

  const deviceFields = {
    router: [
      {
        name: 'apn',
        label: translations[language]?.apn,
        requiredMsg: translations[language]?.apnRequired
      },
      {
        name: 'vpnCertificateNames',
        label: translations[language]?.vpnCertificateNames,
        requiredMsg: translations[language]?.vpnCertificateNamesRequired
      },
      {
        name: 'vpnIP',
        label: translations[language]?.vpnIP,
        requiredMsg: translations[language]?.vpnIPRequired
      }
    ],
    'passenger-counters': [
      {
        name: 'passengerIp',
        label: translations[language]?.passengerIp,
        requiredMsg: translations[language]?.passengerIpRequired
      },
      {
        name: 'passengerCounterPositioning',
        label: translations[language]?.passengerCounterPositioning,
        requiredMsg: translations[language]?.passengerCounterPositioningRequired,
        className: 'margin-bottom-24',
        options: [
          { label: translations[language]?.optionFront, value: 'front' },
          { label: translations[language]?.optionRear, value: 'rear' },
          { label: translations[language]?.optionCentral, value: 'central' }
        ]
      }
    ],
    validators: [
      {
        name: 'validatorPositioning',
        label: translations[language]?.validatorPositioning,
        requiredMsg: translations[language]?.validatorPositioningRequired,
        className: 'margin-bottom-24',
        options: [
          { label: translations[language]?.optionFront, value: 'front' },
          { label: translations[language]?.optionRear, value: 'rear' },
          { label: translations[language]?.optionCentral, value: 'central' }
        ]
      },
      {
        name: 'terminalId',
        label: translations[language]?.terminalId,
        requiredMsg: translations[language]?.terminalIdRequired
      },
      {
        name: 'validatorIp',
        label: translations[language]?.validatorIp,
        requiredMsg: translations[language]?.validatorIpRequired
      },
      {
        name: 'posSerialNumber',
        label: translations[language]?.posSerialNumber,
        requiredMsg: translations[language]?.posSerialNumberRequired
      }
    ],
    'lcd-displays': [
      {
        name: 'lcdIp',
        label: translations[language]?.lcdIp,
        requiredMsg: translations[language]?.lcdIpRequired
      }
    ],
    mdvr: [
      {
        name: 'mdvrIp',
        label: translations[language]?.mdvrIp,
        requiredMsg: translations[language]?.mdvrIpRequired
      }
    ],
    xpad: [
      {
        name: 'xpadIp',
        label: translations[language]?.xpadIp,
        requiredMsg: translations[language]?.xpadIpRequired
      }
    ]
  }

  const handleAction = async () => {
    const isTokenValid = await verifyToken(history, dispatch);
    if (!isTokenValid) {
      message.error('Session expired. Please log in again.');
      return;
    }
    try {
      // Validate fields (force required rules to trigger)
      await addDevice.validateFields();
    }
    catch (err) {
      return; // Exit if validation fails
    }
    const values = addDevice.getFieldsValue()

    // console.log(values, 'values')
    if (values?.installationDate) {
      values.installationDate = values?.installationDate.format('YYYY-MM-DD')
    }

    const organizationIdToSend = user?.role === "superAdmin" ? values?.organization : organizationDetails?.id

    try {
      setAddDataLoading(true)
      const response = await secureApi.post(POST?.ADD_DEVICE, {
        userId: userId,
        deviceType: values?.deviceType,
        brand: values?.brand,
        installationDate: values?.installationDate,
        macAddress: values?.macAddress,
        model: values?.model,
        apn: values?.apn,
        vpnIP: values?.vpnIP,
        vpnCertificateNames: values?.vpnCertificateNames,
        passengerCounterPositioning: values?.passengerCounterPositioning,
        passengerIp: values?.passengerIp,
        validatorPositioning: values?.validatorPositioning,
        terminalId: values?.terminalId,
        validatorIp: values?.validatorIp,
        posSerialNumber: values?.posSerialNumber,
        xpadIp: values?.xpadIp,
        lcdIp: values?.lcdIp,
        mdvrIp: values?.mdvrIp,
        serialNumber: values?.serialNumber,
        vehicleAssociation: values?.vehicleAssociation,
        // organizationId: organizationDetails?.id
        organizationId: organizationIdToSend,
        routerType: values?.routerType?.toLowerCase()

      })
      if (response.success === true) {
        message.success(translations?.[language]?.deviceAdded)
        fetchFilteredDevices()
        fetchDevices({ setDevicesData, setDevicePercentage, setTotalDevices, dispatch, setDevices, user, organizationId })
        addDevice.resetFields()
        setIsModalVisible(false)
      }
      else if (response?.success === false) {
        message.error(response?.error || response?.message)
      }
    }
    catch (error) {
      // console.log(error, 'error')
      if (error.response?.message) {
        message.error(error.response.message)
      }
      else {
        message.error({
          content: translations?.[language]?.addDeviceError,
          style: { zIndex: 1050 }
        })
      }
    }
    finally {
      setAddDataLoading(false)
    }

  }

  const showSearchModal = () => {
    // Refresh the per-organization totals shown in the panel on open.
    if (!searchModal) fetchAllOrganization({ dispatch })
    setSearchModal(!searchModal)
  }

  const showModal = async () => {
    setIsModalVisible(true)
    setSelectedDeviceType('router')
    addDevice.resetFields()
    // addDevice.setFieldsValue({ deviceType: 'router' })
    addDevice.setFieldsValue({
      deviceType: 'router',
      routerType: 'elmec',
      organization: null,  // Reset organization
      vehicleAssociation: null, // Reset vehicle selection
    })

    setSelectOrgFilter(null) // Reset filter

    if (isModalVisible) {
      await fetchVehicles({ setTotalVehicles, setVechiclesData, dispatch, user, organizationId })
    }
  }

  const viewDetails = (record) => {
    const vehicleDetails = vehicles.find((v) => v.id === record.vehicle_id)
    // setSelectedRecord(record)
    setSelectedRecord({
      ...record,
      vehicle_name: vehicleDetails ? vehicleDetails?.vehicle_name : translations[language]?.noVehicleAssigned,
      vehicle_model: vehicleDetails ? vehicleDetails?.vehicle_model : 'No Model Available',
      logo: vehicleDetails ? vehicleDetails?.logo : 'No Logo Available'

    })
    setViewModal(true)
  }

  const handleOrganizationChange = (value) => {
    dispatch(setOrganizationFilter(value))
    fetchDevices({ setDevicesData, setDevicePercentage, setTotalDevices, dispatch, setDevices, user, organizationId: value })
  }

  const handleUserChange = (value) => {
    setSelectedUsers(value)
    dispatch(setUsersAdminFilter(value))
  }

  const selectOrganizationFilter = (orgId) => {
    setSelectOrgFilter(orgId)
    addDevice.setFieldsValue({
      vehicleAssociation: null
    })
  }

  const handleClose = () => {
    setIsModalVisible(false)
    addDevice.resetFields()
  }

  const closeDetails = () => {
    setSelectedRecord(null)
    setDeviceInfo(null)
    setViewModal(false)
  }

  // Shape the drawer's device into what VehicleMap expects, so the side view
  // shows the same map (live marker, GPS trace, schedule route, stops) as the
  // Vehicle Details page. Falls back to the row data when the info call has
  // not returned yet.
  const drawerVehicleDetails = {
    id: deviceInfo?.vehicleId || selectedRecord?.vehicle_id || null,
    logo: deviceInfo?.logoUrl || null,
    vehicle_name: deviceInfo?.vehicleName || selectedRecord?.vehicle_name || selectedRecord?.registering_number || '-',
    vehicle_model: deviceInfo?.vehicleModel || '-',
    registering_number: selectedRecord?.registering_number || null,
  }
  const hasDeviceLocation =
    Number.isFinite(parseFloat(deviceInfo?.lat)) && Number.isFinite(parseFloat(deviceInfo?.lng))

  const closeEditModal = () => {
    setEditModal(false)
    editUserForm.resetFields()

  }

  const openEditModal = () => {
    setViewModal(false)
    setEditModal(true)
  }

  const handleSearch = (query) => {
    setSearchQuery(query)
  }

  const handleDateChange = (date) => {
    setSelectedDate(date)
  }

  const handleUpdateDevices = async () => {
    const isTokenValid = await verifyToken(history, dispatch)

    if (!isTokenValid) {
      message.error('Session expired. Please log in again.')
      return
    }


    try {
      await editUserForm.validateFields()
    } catch (err) {
      return;
    }
    setEditDataLoading(true)
    try {
      const values = editUserForm.getFieldsValue()
      // console.log(values, 'values')
      const response = await secureApi.post(POST?.UPDATE_ADD_DEVICE, {
        id: toEdit?.id,
        uniqueId: values?.uniqueId,
        deviceType: values?.deviceType,
        model: values?.model,
        brand: values?.brand,
        vehicleAssociation: values?.vehicleAssociation,
        installationDate: values?.installationDate,
        router: values?.router,
        model: values?.model,
        apn: values?.apn,
        vpnIP: values?.vpnIP,
        vpnCertificateNames: values?.vpnCertificateNames,
        passengerCounterPositioning: values?.passengerCounterPositioning,
        passengerIp: values?.passengerIp,
        validatorPositioning: values?.validatorPositioning,
        terminalId: values?.terminalId,
        validatorIp: values?.validatorIp,
        posSerialNumber: values?.posSerialNumber,
        xpadIp: values?.xpadIp,
        lcdIp: values?.lcdIp,
        mdvrIp: values?.mdvrIp,
        // routerPassword: values?.routerPassword,
        macAddress: values?.macAddress,
        serialNumber: values?.serialNumber,
        routerType: values?.routerType?.toLowerCase(),
        organization: values?.organization,
      })
      // console.log(response, 'response')
      if (response?.success === true) {
        message.success(translations[language]?.deviceUpdated)
        fetchFilteredDevices()
        fetchDevices({ setDevicesData, setDevicePercentage, setTotalDevices, dispatch, setDevices, user, organizationId })
        editUserForm.resetFields()
        setEditModal(false)

      } else if (response?.success === false) {
        message.error(response?.error || response?.message)
      }
    } catch (error) {
    }
    finally {
      setEditDataLoading(false)
    }
  }

  const handleEdit = async (record) => {
    setViewModal(false)
    const isTokenValid = await verifyToken(history, dispatch);
    if (!isTokenValid) {
      message.error('Session expired. Please log in again.');
      return;
    }

    // Check permissions
    const isOwner = record?.user_id === userId;
    const isAdmin = user?.role === 'admin';
    const isSuperAdmin = user?.role === 'superAdmin';
    if (!isOwner && !isAdmin && !isSuperAdmin) {
      message.error(translations[language]?.unauthorizedDeviceEdit);
      return;
    }

    // Set loading state
    setVehicleLoading(true);
    setLoadingFormData(true)
    try {
      // Set edit state
      setEditModal(true);
      setToEdit(record);
      setSelectedDeviceType(record?.device_type);

      // Use device's organization ID for filtering
      const selectedOrgId = record?.organization_id;
      setSelectOrgFilter(selectedOrgId);

      // Fetch vehicles for the organization
      await fetchVehicles({
        setTotalVehicles,
        setVechiclesData,
        dispatch,
        user,
        organizationId: selectedOrgId
      });

      // Prime the association dropdown for the device's current organization
      // (falls back to the user's own org for legacy rows without one).
      refetchEditAssociationList(record?.organization_id, record?.device_type)

      // Set form values
      editUserForm.setFieldsValue({
        deviceType: record?.device_type,
        model: record?.model,
        brand: record?.brand,
        vehicleAssociation: record?.registering_number,
        installationDate: record?.installation_date ? moment(record.installation_date) : null,
        macAddress: record?.mac_address,
        router: record?.router,
        serialNumber: record?.serial_number,
        routerType: record?.router_type,
        organization: record?.organization_id,
        // Set device-specific fields
        ...(record?.device_type === 'router' && {
          apn: record?.apn,
          vpnIP: record?.vpn_ip,
          vpnCertificateNames: record?.vpn_certificate_names
        }),
        ...(record?.device_type === 'passenger-counters' && {
          passengerIp: record?.passenger_ip,
          passengerCounterPositioning: record?.passenger_counter_positioning
        }),
      });

    } catch (error) {
      console.error("Error in handleEdit:", error);
      message.error("Failed to load device data");
    } finally {
      setVehicleLoading(false)
      setLoadingFormData(false)
    }
  }

  const handleDelete = async (record) => {
    const isTokenValid = await verifyToken(history, dispatch);
    if (!isTokenValid) {
      message.error('Session expired. Please log in again.');
      return;
    }
    setUserToDelete(record)
    setDeleteModal(true)
  }

  const handleCancel = () => {
    setDeleteModal(false)
    setUserToDelete(null)
  }

  const handleConfirmDelete = async () => {
    const isTokenValid = await verifyToken(history, dispatch)

    if (!isTokenValid) {
      message.error('Session expired. Please log in again.')
      return
    }

    setDeleteModal(false)
    setLoading(true)

    if (userToDelete) {
      try {
        const response = await secureApi.post(POST?.DELETE_DEVICE, {
          id: userToDelete?.id,
          userId: userId
        })
        if (response?.success === true) {
          message.success(translations[language]?.deviceDeleted)
          const updatedDevices = devices?.filter(devices => devices?.id !== userToDelete?.id)
          dispatch(setDevicesData(updatedDevices))
          fetchFilteredDevices()
          dispatch(setTotalDevices(updatedDevices?.length))
          fetchSerialNumbers({ dispatch, selectedRouterType, setAvailableSerialNumbers })
          fetchDevices({ setDevicesData, setDevicePercentage, setTotalDevices, dispatch, setDevices, user, organizationId })
        }
        else if (response?.success === false) {
          message.error(response?.message || 'Failed to delete vehicle.')
        }
      }
      catch (error) {
        message.error(error.response?.message || 'Failed to delete vehicle. Please try again.')
      }

      setLoading(false)
    }

    setUserToDelete(null)
  }

  const handleScanResult = (result) => {
    const parsedData = {}
    const resultLines = result.split('\n')
    resultLines.forEach(line => {
      const [key, value] = line.split(':').map(item => item.trim())
      if (key && value) {
        parsedData[key] = value
      }
    })
    const mappedData = {
      model: parsedData?.Model,
      serialNumber: parsedData?.SN,
      macAddress: parsedData?.['Mac Address'],
      // router: parsedData?.['Router User'],
      // routerPassword: parsedData?.['Router Password'],
    }
    addDevice.setFieldsValue(mappedData)
  }

  const columns = [
    {
      title: translations?.[language]?.serialNumber,
      dataIndex: 'serial_number',
      key: 'serialNumber',
      render: (text, record) => {
        const displayText = (!text || text === 'NULL' || text === 'null' || text === 'undefined')
          ? '-'
          : text;

        const truncated = displayText.length > 12 ? displayText.slice(0, 12) + '...' : displayText;

        return (
          <div className='vl-name-cell' onClick={() => viewDetails(record)}>
            <Tooltip title={displayText} placement="top">
              <span className='vl-name-text capitalized-name'>{truncated}</span>
            </Tooltip>
            {record?.device_type === 'router' && (
              <span className={`dash-status-pill ${record?.is_online ? 'dash-status-ok' : 'dash-status-ko'}`}>
                <span className='dash-status-dot' />
                {record?.is_online
                  ? (translations[language]?.online || 'Online')
                  : (translations[language]?.offline || 'Offline')}
              </span>
            )}
            <FaEye className='vl-name-view' />
          </div>
        );
      },
    },
    {
      title: translations?.[language]?.deviceId,
      dataIndex: 'ud_sn',
      key: 'udSn',
      render: (text) => (
        (!text || text === 'NULL' || text === 'null' || text === 'undefined')
          ? <span className='vl-muted'>-</span>
          : <span className='vl-plate'>{text}</span>
      ),
    },
    // {
    //   title: translations?.[language]?.deviceName,
    //   dataIndex: 'device_name',
    //   key: 'userName',
    //   ellipsis: true,
    //   width: 200,
    //   render: (text, record) => {
    //     return (
    //       <div onClick={() => viewDetails(record)} style={{ width: 100, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
    //         <FaEye style={{ marginRight: 8, color: '#ED2328', marginTop: '1px', minWidth: '1rem' }} />
    //         <Tooltip title={(!text || text === 'NULL' || text === 'null' || text === 'undefined') ? '-' : text} placement="top">
    //           <span className='capitalized-name'>
    //             {(!text || text === 'NULL' || text === 'null' || text === 'undefined') ? '-' : stringLimiter(text)}
    //           </span>
    //         </Tooltip>
    //         {record?.device_type === 'router' ? <Badge status={record?.is_online ? 'success' : 'error'} style={{ marginLeft: 8 }} /> : null}
    //       </div>
    //     );
    //   }
    // },
    {
      title: translations?.[language]?.deviceType,
      dataIndex: 'device_type',
      key: 'deviceType',
      render: (text, record) => {
        if (!text || text === 'NULL' || text === 'null' || text === 'undefined') {
          return <span className='vl-muted'>-</span>;
        }
        const routerType = (!record?.router_type || record?.router_type === 'NULL' || record?.router_type === 'null' || record?.router_type === 'undefined')
          ? '-'
          : record?.router_type;
        return (
          <span className='vl-count-chip capitalized-name'>
            {text}{text === 'router' ? ` (${routerType})` : ''}
          </span>
        );
      },
    },
    {
      title: translations?.[language]?.brand,
      dataIndex: 'brand',
      key: 'brand',
      render: (text) => (!text || text === 'NULL' || text === 'null' || text === 'undefined') ? <span className='vl-muted'>-</span> : text
    },
    {
      title: translations?.[language]?.model,
      dataIndex: 'model',
      key: 'model',
      render: (text) => {
        if (!text || text === 'NULL' || text === 'null' || text === 'undefined') return <span className='vl-muted'>-</span>;
        const key = text.replace(/\s+/g, '').toLowerCase()
        return translations?.[language]?.[key] || text
      }
    },
    // {
    //   title: translations?.[language]?.serialNumber,
    //   dataIndex: 'serial_number',
    //   key: 'serialNumber',
    //   render: (text) => (!text || text === 'NULL' || text === 'null' || text === 'undefined') ? '-' : text
    // },
    {
      title: translations?.[language]?.macAddress,
      dataIndex: 'mac_address',
      key: 'macAddress',
      render: (text) => (!text || text === 'NULL' || text === 'null' || text === 'undefined') ? <span className='vl-muted'>-</span> : <span className='vl-plate'>{text}</span>
    },
    {
      title: translations?.[language]?.association,
      dataIndex: 'registering_number',
      key: 'registering_number',
      // Only the plate in the list; a vehicle without one falls back to the
      // full label so an associated device never reads as unassigned.
      render: (registering_number, record) => (
        record?.license_plate
          ? <span className='vl-plate'>{record.license_plate}</span>
          : vehicleOptionLabel(record)
            ? <span className='capitalized-name'>{vehicleOptionLabel(record)}</span>
            : <span className='vl-muted'>{translations?.[language]?.noVehicleAssigned}</span>
      )
    },
    {
      title: translations?.[language]?.installationDate,
      dataIndex: 'installation_date',
      key: 'installation_date',
      render: (text) => {
        if (!text || text === 'Invalid date' || text === 'undefined' || text === 'null' || text === 'NULL') {
          return <span className='vl-muted'>-</span>;
        }
        const formatted = formatDate(text);
        return formatted === 'Invalid date' ? <span className='vl-muted'>-</span> : <span>{formatted}</span>;
      }
    },
    ...(user?.role === 'superAdmin' ? [
      {
        title: translations[language]?.organizations,
        dataIndex: 'organization_name',
        key: 'organization_name',
        render: (text) => <span className='capitalized-name'>{(!text || text === 'NULL' || text === 'null' || text === 'undefined') ? '-' : text}</span>,
      }
    ] : []),
    ...(user?.role === 'admin' ? [
      {
        title: translations[language]?.createdBy,
        dataIndex: 'created_by',
        key: 'createdBy',
        render: (text, record) => (
          <Tooltip title={(!record.created_by_email || record.created_by_email === 'NULL' || record.created_by_email === 'null' || record.created_by_email === 'undefined') ? '-' : record.created_by_email}>
            <span>{(!text || text === 'NULL' || text === 'null' || text === 'undefined') ? '-' : text}</span>
          </Tooltip>
        ),
      }
    ] : []),
    {
      title: translations?.[language]?.action,
      key: 'action',
      render: (_, record) => (
        <div className='vl-actions'>
          <Tooltip title={translations[language]?.editDevice}>
            <button
              type='button'
              className='vl-action-btn vl-action-edit'
              onClick={() => handleEdit(record)}
            >
              <FaEdit size={14} />
            </button>
          </Tooltip>
          <Tooltip title={translations[language]?.deleteDevice}>
            <button
              type='button'
              className='vl-action-btn vl-action-delete'
              onClick={() => handleDelete(record)}
            >
              <RiDeleteBin6Line size={15} />
            </button>
          </Tooltip>
        </div>
      )
    },
  ]

  const deviceTypeOptions = [
    { label: 'Router', value: 'router' },
    { label: 'Control Unit', value: 'control-unit' },
    { label: 'Passenger Counters', value: 'passenger-counters' },
    { label: 'Validators', value: 'validators' },
    { label: 'LCD Displays', value: 'lcd-displays' },
    { label: 'MDVR', value: 'mdvr' },
    { label: 'XPad', value: 'xpad' },
  ]

  const routerOption = [
    { label: 'Elmec', value: 'elmec' },
    { label: 'Teltonika', value: 'teltonika' }
  ]

  const modelOptions = [
    { label: translations?.[language]?.internal4g, value: 'internal 4g' },
    { label: translations?.[language]?.internal5g, value: 'internal 5g' },
    { label: translations?.[language]?.external5g, value: 'external 5g' }
  ]

  const showSearchUserModal = () => {
    setSearchUserModal(!searchUserModal)
  }

  const downloadDevicePDF = async () => {
    try {
      const isTokenValid = await verifyToken(history, dispatch);
      if (!isTokenValid) {
        message.error('Session expired. Please log in again.');
        return;
      }

      setDownloadLoading(true);

      const params = {
        user_id: user?.id,
        ...(user?.role === 'superAdmin'
          ? { organization_id: organizationFilter }
          : { selectUserId: usersAdminFilter }),
        deviceTypes: selectedDeviceTypes,
        role: user?.role,
        searchQuery,
        language
      };

      const res = await axios.get(GET?.DOWNLOAD_DEVICE_PDF, { params });
      if (res?.data?.success && res?.data?.data) {
        const pdfUrl = res.data.data;

        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = `${language === 'it' ? 'Rapporto_Dispositivi' : 'Device_Report'}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        message.success(
          language === 'it'
            ? 'Rapporto dispositivi scaricato con successo'
            : 'Device report downloaded successfully'
        );
      } else {
        message.error(
          res?.data?.message ||
          (language === 'it'
            ? 'Impossibile scaricare il rapporto dispositivi'
            : 'Failed to download device report')
        );
      }
    } catch (error) {
      console.error('Device PDF download error:', error);
      message.error(
        language === 'it'
          ? 'Errore durante il download del rapporto dispositivi'
          : 'Error downloading device report'
      );
    } finally {
      setDownloadLoading(false);
    }
  }

  return (
    <div className='main-container'>
      <div className='main-inner-container'>
        <div className='insider-container-buttons report-header-div'>

          <h1 className='main-heading'>{translations?.[language]?.devices}</h1>

        </div>
        <div className='insider-container'>
          {devicesFromRedux?.length === 0 ? null : <div className={`dv-toolbar ${user?.role === 'user' ? 'insider-container-buttons' : 'insider-container-buttons insider-container-buttons-two'}`}>
            <div className={`add-button-div ${language === 'it' ? 'add-device-button-main-div' : ''}`}>
              <button type='button' className='add-button' onClick={showModal}
              >
                <FaPlus className={`icon ${language === 'it' ? 'add-device-icon' : ''}`} />
                <span className={`${language === 'it' ? 'add-device-span' : ''}`}>
                  {translations?.[language]?.addDevice}
                </span>
              </button>
            </div>
            <div className={`dv-toolbar-filters ${user?.role === 'user' ? 'search-main-div' : 'search-main-div search-main-div-two'}`}>
              <div className="search-inner-div">
                <Search className="search-icon" />
                <input
                  placeholder={translations[language]?.searchDevices}
                  value={searchQuery}
                  onChange={(e) => handleSearch(e.target.value)}
                  className="search-input"
                />
                {searchQuery && (
                  <span className="clear-icon" style={{ cursor: "pointer" }} onClick={() => handleSearch("")}>
                    ✕
                  </span>
                )}
              </div>
              <div className={`sort-select-wrap ${sortOrder ? 'sort-select-active' : ''}`}>
                <ArrowUpDown className='sort-select-icon' />
                <Select
                  className='sort-select'
                  dropdownClassName='custom-select-dropdown sort-select-dropdown'
                  placeholder={translations[language]?.sortByCreated}
                  value={sortOrder || undefined}
                  onChange={(value) => {
                    setSortOrder(value || '')
                    dispatch(setDevicePageNumber(1))
                  }}
                  bordered={false}
                  allowClear
                  options={[
                    { value: 'desc', label: translations[language]?.newestFirst },
                    { value: 'asc', label: translations[language]?.oldestFirst },
                  ]}
                />
              </div>
              <div
                className={`get-reports-container ${language === 'it' ? 'add-device-button-main-div' : ''}`}
                style={{ marginRight: '10px' }}
              >
                <span
                  type="primary"
                  className={`organization ${searchDeviceTypeModal ? 'open-organization' : 'close-organization'}`}
                  onClick={() => setSearchDeviceTypeModal(!searchDeviceTypeModal)}
                >
                  <DatabaseZap className='add-device-icon ' />
                  <span className='add-device-span'>{translations[language]?.typeOfDevice}
                    {DeviceTypeCount ?
                      <div className="filter-count-badge">
                        {DeviceTypeCount}
                      </div>
                      : null
                    }
                  </span>
                </span>
              </div>
              {user?.role === 'superAdmin' ? <div className='get-reports-container'>
                <span type='primary'
                  className={`organization ${searchModal ? 'open-organization' : 'close-organization'}`}
                  onClick={showSearchModal}
                >
                  <Building2 />
                  {translations[language]?.organizations}
                  {organizationCount ?
                    <div className="filter-count-badge">
                      {organizationCount}
                    </div>
                    :
                    null
                  }
                </span>
              </div> : null}
              {user?.role === 'admin' ?
                <div className='get-reports-container'>
                  <span type='primary'
                    className={`organization ${searchUserModal ? 'open-organization' : 'close-organization'}`}
                    onClick={showSearchUserModal}
                  >
                    <Users />
                    {translations[language]?.users}
                    {userCount ?
                      <div className="filter-count-badge">
                        {userCount}
                      </div>
                      :
                      null
                    }
                  </span>
                </div> : null}
            </div>
          </div>
          }

          <div className='vd-card'>
            {/* Persisted page from redux renders immediately; skeleton only
                on a cold first load. */}
            {!hasLoadedOnce && !(FilterDevicesFromRedux?.length > 0) ? (
              <div className='vd-card-body'>
                <TableSkeleton rows={pageSize > 10 ? 10 : pageSize} columns={user?.role === 'superAdmin' ? 9 : 8} />
              </div>
            ) : devicesFromRedux?.length === 0 ? (
              <div className='vd-card-body'>
                <div className="no-vehicles-container">
                  <div className="no-vehicles-text-center">
                    <div className="flex-col-center">
                      <div className="no-vehicles-text-center">
                        <DatabaseZap className='no-vehicle-icon' />
                        <h3 className="no-vehicles-heading">{translations?.[language]?.noDeviceFound}</h3>
                        <p className="no-vehicles-description">
                          {translations[language]?.addDeviceToSeeListed}
                        </p>
                        <div>
                          <buttons className='add-button' onClick={showModal}
                          >
                            <FaPlus className='icon' />
                            {translations?.[language]?.addDevice}
                          </buttons>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className='vd-card-header'>
                  <div className='vl-list-title'>
                    <h2 className='vd-card-title'>{translations?.[language]?.deviceList}</h2>
                    <span className='vl-total-chip'>
                      {translations?.[language]?.totalRecord}: <strong>{totalFilteredDevices}</strong>
                    </span>
                  </div>
                  <button
                    loading={downloadLoading}
                    type='primary'
                    className='add-button'
                    onClick={downloadDevicePDF}
                  >
                    {translations[language]?.getPDF}
                    <ArrowDownToLine style={{ height: '18px' }} className='icons' />
                  </button>
                </div>
                <div className='vd-card-body'>
                  <Table
                    className='vl-table'
                    dataSource={FilterDevicesFromRedux}
                    columns={columns}
                    pagination={{
                      current: currentPage,
                      pageSize: pageSize,
                      total: totalItems,
                      showSizeChanger: true,
                      showQuickJumper: true,
                      pageSizeOptions,
                      onShowSizeChange: (current, size) => {
                        setPageSize(size);
                        dispatch(setDevicePageNumber(1))
                      },
                      onChange: (page, pageSize) => {
                        dispatch(setDevicePageNumber(page));
                        setPageSize(pageSize);
                      }
                    }}
                    scroll={{ x: 'max-content' }}
                    loading={initialLoading || tableLoading}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <CustomModal
        isVisible={isModalVisible}
        onClose={handleClose}
        title={translations?.[language]?.addDevice}
        actionText={translations?.[language]?.addDevice}
        onAction={handleAction}
        loading={addDataLoading}
        language={language}
      >
        <div>
          <QRCodeScanner onScan={handleScanResult} language={language} />
        </div>
        <Form form={addDevice} layout='vertical'>
          <div className='flex-input'>

            <div
              className={`flex-inner-inputs input-drawer-margin margin-bottom-24 ${user?.role !== "superAdmin" ? "full-width" : ""
                }`}
            >
              <CustomSelect
                label={translations?.[language]?.typeOfDevice}
                name='deviceType'
                placeholder={translations?.[language]?.typeOfDevice}
                options={deviceTypeOptions}
                onChange={handleDeviceTypeChange}
                rules={[{ required: true, message: translations?.[language]?.pleaseEnterTypeOfDevice }]}
                defaultValue="router"
              />
            </div>
            {user?.role === "superAdmin" && (
              <div className='flex-inner-inputs margin-bottom-24'>
                <CustomSelect
                  className='vehicle-org-dropdown'
                  label={translations[language]?.organizations}
                  placeholder={translations[language]?.organizationSelect}
                  name="organization"
                  options={organizations?.map(org => ({
                    label: org?.organization_name,
                    value: org?.id,
                  }))}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={selectOrganizationFilter}
                  rules={[{ required: true, message: translations[language]?.organizationSelect }]}
                />
              </div>
            )}
          </div>
          {selectedDeviceType === 'router' ?
            <div className='flex-inner-inputs'>

              <div className='margin-bottom-24' style={{ position: 'relative' }}>
                <Tooltip title={translations[language]?.teltonikaInstructionsGuide}
                  placement="topRight"
                  overlayStyle={{ maxWidth: 200 }}
                  overlayInnerStyle={{ marginLeft: '-10px' }}>
                  <FaInfoCircle
                    className="teltonika-info-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(allPaths?.TELTONIKA_INSTRUCTION, '_blank', 'noopener,noreferrer');
                    }}
                  />
                </Tooltip>
                <CustomSelect
                  label={translations[language]?.routerType}
                  name='routerType'
                  placeholder={translations?.[language]?.typeOfDevice}
                  options={routerOption}
                  onChange={handleRouterTypeChange}
                  rules={[{ required: true, message: translations?.[language]?.pleaseEnterTypeOfDevice }]}
                  defaultValue='elmec'
                />
              </div>


            </div>
            :
            null
          }

          <div className="dynamic-product">
            {selectedDeviceType && deviceFields?.[selectedDeviceType] && (
              <div className="input-grid">
                {deviceFields[selectedDeviceType]?.map(({ name, label, requiredMsg, options, className }, index, array) => (
                  <div
                    key={name}
                    className={`input-wrapper ${className || ''} ${array.length === 1 || (array.length % 2 !== 0 && index === array.length - 1)
                      ? 'full-width'
                      : ''}`}
                  >
                    {options ? (
                      <CustomSelect
                        label={label}
                        name={name}
                        placeholder={label}
                        options={options}
                        rules={[{ required: true, message: requiredMsg }]}
                      />
                    ) : (
                      <Inputs
                        label={label}
                        name={name}
                        placeholder={label}
                        rules={[{ required: true, message: requiredMsg }]}
                      />
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className='flex-input'>
            <div className='flex-inner-inputs input-drawer-margin'>
              <CustomSelect
                label={translations?.[language]?.model}
                name='model'
                placeholder={translations?.[language]?.placeholder?.model}
                options={modelOptions}
              />

            </div>
            <div className='flex-inner-inputs'>
              <Inputs
                label={translations?.[language]?.brand}
                name='brand'
                placeholder={translations?.[language]?.placeholder?.brand}
              // rules={[{ required: true, message: translations?.[language]?.pleaseEnterBrand }]}
              />
            </div>
          </div>

          <div className='flex-input'>
            <div className='flex-inner-inputs input-drawer-margin'>
              <CustomSelect
                label={translations?.[language]?.immediateAssociationToVehicle}
                name='vehicleAssociation'
                placeholder={translations?.[language]?.immediateAssociationToVehicle}
                options={unassociatedVehicles?.map(vehicle => ({
                  label: vehicleOptionLabel(vehicle),
                  value: vehicle?.id,
                }))}
                filterOption={(input, option) =>
                  (option?.children?.toString()?.toLowerCase() || '').includes(input.toLowerCase())
                }
                rules={[{ required: true, message: translations?.[language]?.pleaseSelectVehicle }]}
              />
            </div>
            <div className='flex-inner-inputs'>
              <Form.Item
                label={translations?.[language]?.installationDate}
                name='installationDate'
              // rules={[{ required: true, message: translations?.[language]?.pleaseSelectInstallationDate }]}
              >
                <Datepicker
                  className='vehicle-datepicker'
                  format={dateFormate}
                  language={language}
                  disabledDate={(current) => current && current > moment().endOf('day')}
                />
              </Form.Item>
            </div>
          </div>

          <div className='flex-input'>
          </div>

          <div className='flex-input'>
            <div className='flex-inner-inputs input-drawer-margin'>
              <Inputs
                label={translations[language]?.macAddress}
                name='macAddress'
                placeholder={translations[language]?.macAddress}
                rules={[{
                  required: selectedDeviceType !== 'router',
                  message: translations[language]?.pleaseEnterMacAddress
                }]} />
            </div>
            <div className='flex-inner-inputs'>
              {selectedDeviceType === 'router' ? (
                <CustomSelect
                  label={translations[language]?.serialNumber}
                  name='serialNumber'
                  placeholder={translations[language]?.placeholder?.serialNumber}
                  options={availableSerials?.map(item => ({
                    label: item.serial_number,
                    value: item.serial_number,
                  }))}
                  showSearch
                  filterOption={(input, option) =>
                    option?.children?.toLowerCase().includes(input.toLowerCase())
                  }
                  rules={[{
                    required: true,
                    message: translations[language]?.pleaseEnterSerialNumber
                  }]}
                />
              ) : (
                <Inputs
                  label={translations[language]?.serialNumber}
                  name='serialNumber'
                  placeholder={translations[language]?.placeholder?.serialNumber}
                  rules={[{
                    required: selectedDeviceType === 'router' ? true : false,
                    message: translations[language]?.pleaseEnterSerialNumber
                  }]}
                />
              )}
            </div>

          </div>
        </Form>
      </CustomModal>


      <CustomModal
        isVisible={viewModal}
        onClose={closeDetails}
        title={translations[language]?.deviceDetails}
        actionText={translations[language]?.editDevice}
        onAction={() => handleEdit(selectedRecord)}
        language={language}
      >
        <div>
          <div className='device-detail-datepicker-div' >
            <Datepicker
              format={dateFormate}
              value={selectedDate}
              language={language}
              onChange={handleDateChange}
            />
          </div>
          <div className='device-information-section'>
            <div className='inner-information-div'>
              <div className='info-childern-div'>
                <div className='inner-information-childern'>
                  <h3 className='info-heading'>{translations[language]?.model}</h3>
                  <p>{selectedRecord?.model ? selectedRecord?.model : '-'}</p>
                </div>
              </div>
              <div className='info-childern-div'>
                <div className='inner-information-childern'>
                  <h3 className='info-heading'>{translations[language]?.brand}</h3>
                  <p>{selectedRecord?.brand ? selectedRecord?.brand : '-'}</p>
                </div>
              </div>
            </div>

            <div className='inner-information-div'>
              <div className='info-childern-div'>
                <div className='inner-information-childern'>
                  <h3 className='info-heading'>{translations[language]?.immediateAssociationToVehicle}</h3>
                  <p>{selectedRecord?.registering_number ? selectedRecord?.registering_number : '-'}</p>
                </div>
              </div>
              <div className='info-childern-div'>
                <div className='inner-information-childern'>
                  <h3 className='info-heading'>{translations[language]?.installationDate}</h3>
                  <p>
                    {selectedRecord?.installation_date ? new Date(selectedRecord.installation_date).toLocaleDateString('en-GB') : '-'}
                  </p>
                </div>
              </div>
            </div>

            <div className='inner-information-div'>
              <div className='info-childern-div'>
                <div className='inner-information-childern'>
                  <h3 className='info-heading'>{translations[language]?.serialNumber}</h3>
                  {/* <p>{selectedRecord?.serial_number}</p> */}
                  <p>{selectedRecord?.serial_number && selectedRecord.serial_number !== "undefined" ? selectedRecord.serial_number : "-"}</p>

                </div>
              </div>
              <div className='info-childern-div'>
                <div className='inner-information-childern'>
                  <h3 className='info-heading'>{translations[language]?.macAddress}</h3>
                  <p>{selectedRecord?.mac_address ? selectedRecord.mac_address : '-'}</p>
                </div>
              </div>
            </div>
            <div className='inner-information-div'>
              <div className='info-childern-div'>
                <div className='inner-information-childern'>
                  <h3 className='info-heading'>{translations[language]?.typeOfDevice}</h3>
                  <p>{selectedRecord?.device_type}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {selectedRecord?.device_type === 'router' && (
          <div className='device-drawer-map-section'>
            <div className='table-header margin-bottom-20'>
              <h1 className='h1-theme-color vehicle-list-heading margin-bottom-0'>
                {translations[language]?.deviceLocation}
              </h1>
            </div>
            {hasDeviceLocation ? (
              <div className='device-drawer-map'>
                <VehicleMap
                  deviceInfo={deviceInfo}
                  vehicleDetails={drawerVehicleDetails}
                  language={language}
                  selectedDate={selectedDate}
                  isLoading={isLoading}
                />
              </div>
            ) : isLoading ? (
              <div className='device-drawer-map-placeholder'>
                <Spin />
                <span>{translations[language]?.loadingDeviceLocation}</span>
              </div>
            ) : (
              <div className='device-drawer-map-placeholder device-drawer-map-empty'>
                {translations[language]?.locationNotFound}
              </div>
            )}
          </div>
        )}

      </CustomModal>

      <CustomModal
        isVisible={editModal}
        onClose={closeEditModal}
        actionText={translations[language]?.updateDevice}
        title={translations[language]?.editDevice}
        onAction={handleUpdateDevices}
        language={language}
        loading={editDataLoading}
      >
        <Form form={editUserForm} layout='vertical'>
          <Spin spinning={loadingFormData}>
            <div className='flex-input'>
              <div
                className={`flex-inner-inputs input-drawer-margin margin-bottom-24 ${user?.role !== "superAdmin" ? "full-width" : ""
                  }`}
              >
                <CustomSelect
                  label={translations?.[language]?.typeOfDevice}
                  name='deviceType'
                  placeholder={translations?.[language]?.typeOfDevice}
                  options={deviceTypeOptions}
                  onChange={handleDeviceEditTypeChange}
                  rules={[{ required: true, message: translations?.[language]?.pleaseEnterTypeOfDevice }]}
                />
              </div>
              {user?.role === "superAdmin" && (

                <div className='flex-inner-inputs margin-bottom-24'>
                  <CustomSelect
                    className='vehicle-org-dropdown'
                    label={translations[language]?.organizations}
                    placeholder={translations[language]?.organizationSelect}
                    name="organization"
                    options={organizations?.map(org => ({
                      label: org?.organization_name,
                      value: org?.id,
                    }))}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={selectEditOrganization}
                    rules={[{ required: true, message: translations[language]?.organizationSelect }]}
                  />
                </div>
              )}
            </div>
            {selectedDeviceType === 'router' ?
              <div className='flex-inner-inputs margin-bottom-24'>
                <CustomSelect
                  label={translations[language]?.routerType}
                  name='routerType'
                  placeholder={translations[language]?.selectRouterType}
                  options={routerOption}
                  onChange={handleRouterTypeChange}
                  rules={[{ required: true, message: translations?.[language]?.pleaseEnterTypeOfDevice }]}
                />
              </div>
              :
              null
            }
            <div className="dynamic-product">
              {selectedDeviceType && deviceFields?.[selectedDeviceType] && (
                <div className="input-grid">
                  {deviceFields[selectedDeviceType]?.map(({ name, label, requiredMsg, options, className }, index, array) => (
                    <div
                      key={name}
                      className={`input-wrapper ${className || ''} ${array.length === 1 || (array.length % 2 !== 0 && index === array.length - 1)
                        ? 'full-width'
                        : ''}`}
                    >
                      {options ? (
                        <CustomSelect
                          label={label}
                          name={name}
                          placeholder={label}
                          options={options}
                          rules={[{ required: true, message: requiredMsg }]}
                        />
                      ) : (
                        <Inputs
                          label={label}
                          name={name}
                          placeholder={label}
                          rules={[{ required: true, message: requiredMsg }]}
                        />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className='flex-input'>
              <div className='flex-inner-inputs input-drawer-margin'>
                <CustomSelect
                  label={translations?.[language]?.model}
                  name='model'
                  placeholder={translations?.[language]?.placeholder?.model}
                  options={modelOptions}
                />
              </div>
              <div className='flex-inner-inputs'>
                <Inputs
                  label={translations[language]?.brand}
                  name='brand'
                  placeholder={translations[language]?.placeholder?.brand}
                />
              </div>
            </div>

            <div className='flex-input'>
              <div className='flex-inner-inputs input-drawer-margin'>
                <CustomSelect
                  label={translations[language]?.immediateAssociationToVehicle}
                  name='vehicleAssociation'
                  placeholder={translations[language]?.placeholder?.immediateAssociationToVehicle}
                  filterOption={(input, option) =>
                    (option?.children?.toString()?.toLowerCase() || '').includes(input.toLowerCase())
                  }
                  options={unassociatedVehicles?.map(vehicle => ({
                    label: vehicleOptionLabel(vehicle),
                    value: vehicle.id,
                  }))}
                  loading={vehicleLoading}
                />
              </div>
              <div className='flex-inner-inputs'>
                <Form.Item
                  label={translations[language]?.installationDate}
                  name='installationDate'
                >
                  <Datepicker
                    className='vehicle-datepicker'
                    format={dateFormate}
                    language={language}
                    disabledDate={(current) => current && current > moment().endOf('day')}
                  />
                </Form.Item>
              </div>
            </div>
            <div className='flex-input'>
              <div className='flex-inner-inputs input-drawer-margin'>
                <Inputs
                  label={translations[language]?.macAddress}
                  name='macAddress'
                  placeholder={translations[language]?.placeholder?.macAddress}
                  rules={[{
                    required: selectedDeviceType !== 'router',
                    message: translations[language]?.pleaseEnterMacAddress
                  }]} />
              </div>
              <div className='flex-inner-inputs'>
                {selectedDeviceType === 'router' ? (
                  <CustomSelect
                    label={translations[language]?.serialNumber}
                    name='serialNumber'
                    placeholder={translations[language]?.placeholder?.serialNumber}
                    options={availableSerials?.map(item => ({
                      label: item.serial_number,
                      value: item.serial_number,
                    }))}
                    showSearch
                    filterOption={(input, option) =>
                      option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                    rules={[{
                      required: true,
                      message: translations[language]?.pleaseEnterSerialNumber
                    }]}
                  />
                ) : (
                  <Inputs
                    label={translations[language]?.serialNumber}
                    name='serialNumber'
                    placeholder={translations[language]?.placeholder?.serialNumber}
                    rules={[{
                      required: selectedDeviceType === 'router' ? true : false,
                      message: translations[language]?.pleaseEnterSerialNumber
                    }]}
                  />
                )}
              </div>
            </div>
          </Spin>
        </Form>
      </CustomModal>

      <DeleteModal
        title={translations[language]?.deleteDevice}
        bodyText={
          <>
            {translations[language]?.areYouSureYouWantToDltThisDevice}
          </>
        }
        isOpen={deleteModal}
        onCancel={handleCancel}
        onDelete={handleConfirmDelete}
        language={language}
      />

      <div className={`search-organization-main-div ${searchModal ? 'open' : ''}`}>
        <SearchOrganizations
          selectedOrganizations={organizationFilter}
          selectedFilter={organizationFilter}
          handleOrganizationChange={handleOrganizationChange}
          organizations={organizations}
          setSearchModal={setSearchModal}
          searchModal={searchModal}
          language={language}
          searchType={"devices"}
        />
      </div>
      <div className={`search-organization-main-div ${searchUserModal ? 'open' : ''}`}>
        <SearchDeviceUser
          language={language}
          selectedUsers={selectedUsers}
          handleUserChange={handleUserChange}
          users={users}
          setSearchUserModal={setSearchUserModal}
          searchUserModal={searchUserModal}
        />
      </div>
      <div className={`search-organization-main-div ${searchDeviceTypeModal ? 'open' : ''}`}>
        <SearchDeviceType
          deviceTypeCounts={deviceTypeCounts}
          selectedTypes={selectedDeviceTypes}
          // handleDeviceTypeChange={setSelectedDeviceTypes}
          setSearchDeviceTypeModal={setSearchDeviceTypeModal}
          searchDeviceTypeModal={searchDeviceTypeModal}
          availableDeviceTypes={deviceTypeOptions}
          language={language}
        />
      </div>

    </div >
  )
}

export default Devices
